import { render } from "./promo-modal.vue?vue&type=template&id=aee74ec6&scoped=true"
import script from "./promo-modal.vue?vue&type=script&lang=js"
export * from "./promo-modal.vue?vue&type=script&lang=js"

import "./promo-modal.vue?vue&type=style&index=0&id=aee74ec6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aee74ec6"]])

export default __exports__